import {
  NgModule
} from '@angular/core';
import {
  OrderDetailComponent
} from './order-detail.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../shared/common';
import {
  LoadingIndicatorModule
} from '../../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {ShippingComponent} from './components/shipping/shipping.component';
import {DialogModule} from '@progress/kendo-angular-dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {FlexLayoutModule} from '@angular/flex-layout';
import {UploadAssetComponent} from './components/upload/upload.component';
import { UploadModule } from '@progress/kendo-angular-upload';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    OrderDetailComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    MatExpansionModule,
    ReactiveFormsModule,
    DialogModule,
    UploadModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule
  ],
  exports: [
  ],
  providers: [
  ],
  entryComponents: [
    ShippingComponent,
    UploadAssetComponent
  ],
})
export class OrderDetailModule {
}
